import MBackdrop from "@mui/material/Backdrop";
import MCard from "@mui/material/Card";
import MCardActions from "@mui/material/CardActions";
import MCardContent from "@mui/material/CardContent";
import MModal from "@mui/material/Modal";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

export const Modal = styled(MModal)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const ModalBackdrop = styled(MBackdrop)(({ theme }) => ({
  opacity: "0.5 !important",
  backgroundColor: theme.palette.grey[500],
}));

export const ModalCard = styled(MCard)(() => ({
  display: "flex",
  flexDirection: "column",
  position: "relative",
  borderRadius: "12px",
}));

export const ModalCardContent = styled(MCardContent)(() => ({
  display: "flex",
  flexDirection: "column",
  paddingTop: "32px",
  paddingLeft: "24px",
  paddingRight: "24px",
  paddingBottom: "32px",
  overflowY: "auto",

  "&::-webkit-scrollbar": {
    width: "4px",
    borderBottomRightRadius: "8px",
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "transparent",
    borderBottomRightRadius: "8px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#667085 !important",
    borderBottomRightRadius: "8px",
  },
}));

export const ModalCardActions = styled(MCardActions)(() => ({}));

export const ModalCardTitleContainer = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  paddingTop: "24px",
  paddingRight: "24px",
  paddingLeft: "24px",
}));

export const ModalCardTitleLabel = styled(Typography)(() => ({
  fontSize: "22px",
  fontWeight: 700,
  lineHeight: "28px",
}));
